export function isProductViewModel(product: ProductViewModel | ListingCardModel): product is ProductViewModel {
  if ((product as ProductViewModel).agilityId > 0) {
    return true;
  }

  return false;
}

export function isListingCardModel(card: ProductViewModel | ListingCardModel): card is ListingCardModel {
  if ((card as ListingCardModel).displayOnEveryPage !== undefined) {
    return true;
  }

  return false;
}

export function isLoqateValidResponse(
  response: LoqateFindResponse<unknown>,
): response is LoqateFindResponse<LoqateFindResponseItem> {
  if (response.Items.length === 0) {
    return true;
  }

  if ((response as LoqateFindResponse<LoqateFindResponseItem>).Items[0].Id) {
    return true;
  }

  return false;
}

export function isLoqateFindResponseItem(response: unknown): response is LoqateFindResponseItem {
  if ((response as LoqateFindResponseItem).Text) {
    return true;
  }

  return false;
}
